import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import MobileModalFocusGuard from './components/MobileModalFocusGuard';
import CreateLeadValidationGuard from './components/CreateLeadValidationGuard';
import './styles.css';
import './report-responsive.css';
import './activity-ledger.css';
import './audit-history.css';
import './qualification-match.css';
import './notifications.css';
import './create-lead-compact.css';
import './create-lead-v2.css';
import './create-lead-height.css';
import './inbound-lists.css';
import './team-admin.css';
import './purge-settings.css';
import './data-integrations.css';
import './mobile-responsive.css';
import './mobile-app-shell.css';
import './mobile-overlays.css';
import './mobile-leads-controls.css';
import './mobile-today-header.css';
import './activity-mobile-redesign.css';
import './sidebar-shortcuts.css';
import './mobile-pass2.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <MobileModalFocusGuard />
        <CreateLeadValidationGuard />
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
